import type { KycState, LinkedBank, WalletBalances, WalletTransaction } from '@tradekaro/shared';

export const WALLET_BALANCES: WalletBalances = {
  totalCash: 84210.0,
  available: 62480.0,
  inOpenOrders: 18450.0,
  unsettled: 3280.0,
  dividendsPocket: 8315.0,
};

export const LINKED_BANKS: LinkedBank[] = [
  { id: 'mcb-1234', bank: 'MCB Bank', iban: 'PK36 MCB0 0000 0000 1234 5678', accountTitle: 'Ali Raza', primary: true, verified: true, lastUsed: 'Apr 22, 2026' },
  { id: 'meb-9921', bank: 'Meezan Bank', iban: 'PK02 MEZN 0001 0099 8765 4321', accountTitle: 'Ali Raza', primary: false, verified: true, lastUsed: 'Mar 14, 2026' },
  { id: 'hbl-5544', bank: 'HBL', iban: 'PK14 HABB 0011 5544 3322 0099', accountTitle: 'Ali Raza', primary: false, verified: false, lastUsed: null },
];

export const WALLET_TXNS: WalletTransaction[] = [
  { id: 't1', type: 'DEPOSIT', method: 'Raast', amount: 50000, status: 'completed', date: 'Apr 27, 2026', time: '09:15', ref: 'RST-2046-8821', counterparty: 'MCB ••5678' },
  { id: 't2', type: 'BUY', sym: 'MEBL', amount: -22620, status: 'completed', date: 'Apr 27, 2026', time: '10:42', ref: 'ORD-44199', qty: 100, price: 226.2 },
  { id: 't3', type: 'DIVIDEND', sym: 'ENGROH', amount: 1875, status: 'completed', date: 'Apr 24, 2026', time: '14:30', ref: 'DIV-ENG-Q1', perShare: 7.5, qty: 250 },
  { id: 't4', type: 'SELL', sym: 'OGDC', amount: 28810, status: 'settled', date: 'Apr 24, 2026', time: '11:08', ref: 'ORD-44012', qty: 200, price: 144.05 },
  { id: 't5', type: 'WITHDRAW', method: 'IBFT', amount: -15000, status: 'completed', date: 'Apr 22, 2026', time: '16:45', ref: 'WD-66341', counterparty: 'MCB ••5678' },
  { id: 't6', type: 'DEPOSIT', method: 'IBAN', amount: 100000, status: 'completed', date: 'Apr 18, 2026', time: '13:20', ref: 'IBT-9921002', counterparty: 'Meezan ••4321' },
  { id: 't7', type: 'DIVIDEND', sym: 'MEBL', amount: 3200, status: 'completed', date: 'Apr 02, 2026', time: '11:00', ref: 'DIV-MEB-Q1', perShare: 4.0, qty: 800 },
  { id: 't8', type: 'BUY', sym: 'TRG', amount: -72300, status: 'completed', date: 'Mar 28, 2026', time: '10:14', ref: 'ORD-43881', qty: 1500, price: 48.2 },
  { id: 't9', type: 'FEE', label: 'Brokerage', amount: -84, status: 'completed', date: 'Mar 28, 2026', time: '10:14', ref: 'FEE-43881' },
  { id: 't10', type: 'DEPOSIT', method: 'Raast', amount: 25000, status: 'completed', date: 'Mar 22, 2026', time: '08:50', ref: 'RST-2032-4410', counterparty: 'MCB ••5678' },
];

export const KYC_STATE: KycState = {
  status: 'pending',
  step: 'bank-verification',
  completedSteps: ['cnic', 'liveness', 'address'],
  pendingSteps: ['bank-verification'],
  estCompletion: '24 hours',
};
